import { DatePicker, DatePickerProps } from '@applyboard/crystal-ui';
import {
  convertTimelessDateStrToLocalDate,
  getLocalTimelessDateStrFromISOStr,
} from '~/utils/dates';

export function TimelessDateStringInput({ value, onChange, ...otherProps }: DatePickerProps) {
  return (
    <div css={{ width: '100%' }}>
      <DatePicker
        value={value ? convertTimelessDateStrToLocalDate(value).toISOString() : value}
        onChange={newValue => {
          onChange(newValue ? getLocalTimelessDateStrFromISOStr(newValue) : newValue);
        }}
        {...otherProps}
      />
    </div>
  );
}
